type Props = {
  width?: number;
  height?: number;
  className?: string;
};

const BackToTopArrow = (props: Props) => {
  const { width = 85, height = 85, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 85 85"
      className={className}
    >
      <circle
        cx={42.13}
        cy={42.13}
        r={42}
        className="fill-surface-secondary stroke-skin-stroke stroke-2"
        transform="rotate(-90.177 42.13 42.13)"
      />
      <path
        className="fill-skin-primary"
        d="M40.63 31.83 29.28 43.18c-.3.3-.65.45-1.05.45s-.75-.15-1.05-.45c-.3-.3-.45-.65-.45-1.05s.15-.75.45-1.05l13.9-13.9c.167-.167.334-.284.5-.35.167-.067.35-.1.55-.1.2 0 .384.033.55.1.167.066.334.183.5.35l13.9 13.9c.3.3.45.65.45 1.05s-.15.75-.45 1.05c-.3.3-.65.45-1.05.45s-.75-.15-1.05-.45L43.63 31.83v24.8c0 .433-.141.791-.425 1.075-.283.283-.641.425-1.075.425-.433 0-.791-.142-1.075-.425-.283-.284-.425-.642-.425-1.075v-24.8Z"
      />
    </svg>
  );
};
export default BackToTopArrow;
